import routes from '@/app/routes';
import type { AppDetail } from './home.types';

export const LIST_OF_APPS: Array<AppDetail> = [
  {
    id: 'matchmaker',
    title: 'Matchmaker',
    description: 'Web and mobile access to track task in real time.',
    thumbnail: '/apps/matchmaker.png',
    link: routes.MATCH_MAKER,
  },
  {
    id: 'production-reporting',
    title: 'Production reporting',
    description:
      'Quis platea condimentum amet suspendisse. Vulputate sollicitudin.',
    thumbnail: '/apps/production_reporting.png',
    link: routes.PRODUCTION_REPORTING,
  },
  {
    id: 'stock-reconciliation',
    title: 'Stock reconciliation',
    description:
      'Lorem faucibus aliquam duis laoreet dui in semper metus. Semper sem.',
    thumbnail: '/apps/stock_reconciliation.png',
    link: routes.STOCK_RECONCILIATION,
    disabled: true,
  },
  {
    id: 'soft-tag-manager',
    title: 'Soft tag manager',
    description:
      'Lorem faucibus aliquam duis laoreet dui in semper metus. Semper sem.',
    thumbnail: '/apps/soft_tag_manager.png',
    link: import.meta.env.VITE_APP_SOFT_TAG_MANAGER_URL,
  },
];
